import { motion } from "framer-motion";

export default function ScrollReveal({
  children,
  delay = 0,
  y = 40,
  duration = 0.8,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{
        duration,
        delay,
        ease: [0.22, 1, 0.36, 1], // smooth cubic-bezier
      }}
    >
      {children}
    </motion.div>
  );
}